// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1KXlC","head":"Table_head__fS7ca","col":"Table_col__ifukH"};